import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import {
  ReviewAnalysisReviewsResponse,
  ReviewsQueryParams,
} from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

type ReviewsParams = Omit<ReviewsQueryParams, 'page'>

// Infinite (scroll-loaded) reviews list. `page` is supplied by the query, so it
// is omitted from the caller-provided params.
export const useGetReviewAnalysisReviewsQuery = (
  campaignId: string,
  params: ReviewsParams
) =>
  useInfiniteQuery<
    ReviewAnalysisReviewsResponse,
    Error,
    InfiniteData<ReviewAnalysisReviewsResponse>,
    [QueryKey, string, ReviewsParams],
    number
  >({
    enabled: !!campaignId,
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.pages ? lastPage.page + 1 : undefined,
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      ReviewAnalysisApiService.getReviews(campaignId, {
        ...params,
        page: pageParam,
      }),
    queryKey: [QueryKey.GET_REVIEW_ANALYSIS_REVIEWS, campaignId, params],
  })
